/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-11-08, 11:53:38
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2017-12-04, 14:54:06
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

import {
  FILL_NOTIFY_STATUSES_DEFINITION, FILL_CONNECTIONS_LIST, CLEAR_CONNECTION_LIST,
  SET_CONNECTIONS_DOWNLOAD_PARAMS, INCREASE_NOTES_COUNT_IN_CONNECTION_RECORD,
} from './mutation-types';

export default {
  [FILL_NOTIFY_STATUSES_DEFINITION](state, payload) {
    const _state = state;
    _state.settings.notifyStatuses = payload.notifyStatuses;
  },

  [SET_CONNECTIONS_DOWNLOAD_PARAMS](state, payload) {
    const _state = state;
    _state.connections.filters = payload.filters;
    _state.connections.page = payload.page || 1;
  },

  [FILL_CONNECTIONS_LIST](state, payload) {
    const _state = state;
    _state.connections.list = payload.connections;
  },

  [CLEAR_CONNECTION_LIST](state) {
    const _state = state;
    _state.connections.list = [];
  },

  [INCREASE_NOTES_COUNT_IN_CONNECTION_RECORD](state, payload) {
    const _state = state;
    const index = _state.connections.list.records.findIndex(connection => connection.id === payload.connectionId);
    const currentNumberOfNotes = _state.connections.list.records[index].notes;
    _state.connections.list.records[index].notes = currentNumberOfNotes + 1;
  },
};
